import { faBus } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { allRoutes } from "generated/routes"
import { NavLink } from "react-router-dom"
import { StyledAvatar, StyledCard, StyledCardContent } from "shared/styled/General"

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  textDecoration: "none"
}))

const NoDataCard = () => {
  return (
    <Grid xs={12} md={8} item>
      <StyledCard>
        <StyledCardContent>
          <StyledAvatar aria-label="recipe">
            <FontAwesomeIcon size="lg" icon={faBus} />
          </StyledAvatar>
          <Typography variant="h3">
            Du har för närvarande inte några fordon upplagda i ditt fordonsregister. Klicka
            <StyledNavLink to={allRoutes.VehicleregistryVehiclesImport()}> här</StyledNavLink> för att
            importera fordon.
          </Typography>
        </StyledCardContent>
      </StyledCard>
    </Grid>
  )
}

export default NoDataCard
